import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import WhatsApp from "../../assets/whatsapp.png";

import { useNavigate } from "react-router-dom";

import aboutHero from "../../assets/ecoTrail-hero.jpg";

import dhamma from "../../assets/place19.jpg";
import sigiriya from "../../assets/cable.jpg";
import kandy from "../../assets/oruwa.jpg";
import temple from "../../assets/ella-3.jpg";

function NatureAndAdventureTour() {

    const navigate = useNavigate();

    const images = [dhamma, sigiriya, kandy, temple];

    const [selectedImage, setSelectedImage] = useState(images[0]);

    const [day1, setDay1] = useState(true);
    const [day2, setDay2] = useState(false);
    const [day3, setDay3] = useState(false);
    const [day4, setDay4] = useState(false);
    const [day5, setDay5] = useState(false);
    const [day6, setDay6] = useState(false);
    const [day7, setDay7] = useState(false);
    const [day8, setDay8] = useState(false);

    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO ================= */}
            <section className="relative h-[40vh] w-full">
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{ backgroundImage: `url(${aboutHero})` }}
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white">
                    <h1
                        data-aos="fade-up"
                        className="text-3xl sm:text-4xl md:text-5xl lg:text-4xl font-extrabold leading-tight"
                    >
                        Nature & Adventure Tour
                    </h1>
                    <p
                        data-aos="fade-up"
                        data-aos-delay="150"
                        className="mt-4 sm:mt-6 max-w-full sm:max-w-2xl md:max-w-3xl text-sm sm:text-base md:text-lg"
                    >
                        Experience the wild beauty and thrilling adventures of Sri Lanka’s landscapes.
                    </p>
                </div>
            </section>

            {/* ================= CULTURAL HIGHLIGHTS ================= */}
            <section className="bg-white -py-2">
                <div className="mx-auto max-w-7xl px-6 text-center">

                    <p
                        data-aos="fade-up"
                        data-aos-delay="150"
                        className="mx-auto mt-6 max-w-4xl text-gray-600 leading-relaxed"
                    >
                        This 8-day Nature & Adventure Tour highlights the best of Sri Lanka’s culture, scenery, and wildlife.

                        Begin in Sigiriya with a climb up the iconic Lion Rock for stunning panoramic views. Continue to Kandy to visit the sacred Temple of the Tooth and enjoy traditional Kandyan dance performances. Travel through the misty tea plantations of Nuwara Eliya before taking a scenic train ride to Ella, known for its breathtaking landscapes and the famous Nine Arches Bridge.

                        Head into the wild with a safari at Yala National Park, where you may spot elephants, leopards, and other exotic wildlife in their natural habitat. End your journey in the coastal city of Galle, exploring its historic Dutch Fort and relaxing seaside views.

                        Perfect for travelers seeking a balanced mix of adventure, culture, and nature in Sri Lanka.
                    </p>

                    {/* Duration Bar */}
                    <div
                        data-aos="fade-up"
                        data-aos-delay="250"
                        className="mx-auto mt-10 flex max-w-4xl items-center justify-center rounded-md bg-gradient-to-r from-[#0A3A5E] to-[#1C6EA4] py-5 text-white"
                    >
                        <div className="flex items-center gap-4">
                            <span className="text-3xl">📅</span>
                            <div className="text-left">
                                <p className="text-sm uppercase tracking-widest">Duration</p>
                                <p className="text-xl font-bold">8 Days / 7 Nights</p>
                            </div>
                        </div>
                    </div>

                    {/* Main Image */}
                    <div
                        data-aos="zoom-in"
                        data-aos-delay="300"
                        className="mx-auto mt-10 overflow-hidden rounded-xl shadow-xl"
                    >
                        <img
                            src={selectedImage}
                            alt="Selected Tour"
                            className="w-full h-[250px] sm:h-[350px] md:h-[450px] lg:h-[600px] xl:h-[720px] object-cover transition duration-500"
                        />
                    </div>

                    {/* Thumbnail Gallery */}
                    <div
                        data-aos="fade-up"
                        data-aos-delay="400"
                        className="mx-auto mt-8 grid max-w-5xl grid-cols-2 gap-4 sm:grid-cols-4"
                    >
                        {images.map((img, index) => (
                            <img
                                key={index}
                                src={img}
                                onClick={() => setSelectedImage(img)}
                                className={`h-28 w-full cursor-pointer rounded-lg object-cover transition-all duration-300 
                                hover:scale-105
                                ${selectedImage === img ? "ring-4 ring-[#0A3A5E]" : "opacity-70"}
                            `}
                            />
                        ))}
                    </div>

                </div>
            </section>

            {/* ================= TOUR ITINERARY ================= */}
            <section className="bg-gray-50 py-10">
                <div className="mx-auto max-w-6xl px-6">

                    <h2
                        data-aos="fade-up"
                        className="text-center text-3xl sm:text-4xl md:text-5xl lg:text-4xl font-extrabold leading-tight"
                    >
                        Tour Itinerary
                    </h2>

                    <div className="mt-12 space-y-6">

                        {/* ================= DAY 1 ================= */}
                        <div data-aos="fade-up" className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay1(!day1)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 1: Arrival in Colombo & Pinnawala Elephant Experience</span>
                                <span>{day1 ? "−" : "+"}</span>
                            </button>

                            {day1 && (
                                <div className="space-y-4 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Arrival at Bandaranaike International Airport.</p>
                                    <p>Visit Pinnawala Elephant Orphanage (feeding & bathing elephants).</p>
                                    <p>Transfer to Sigiriya.</p>
                                    <p className="font-semibold">Overnight stay in Sigiriya.</p>
                                </div>
                            )}
                        </div>

                        {/* ================= DAY 2 ================= */}
                        <div data-aos="fade-up" data-aos-delay="150" className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay2(!day2)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 2: Sigiriya Rock & Minneriya Elephant Safari</span>
                                <span>{day2 ? "−" : "+"}</span>
                            </button>

                            {day2 && (
                                <div className="space-y-4 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Climb Sigiriya Lion Rock Fortress.</p>
                                    <p>Optional village safari experience.</p>
                                    <p>Evening Minneriya / Kaudulla Jeep Safari (Elephant Gathering).</p>
                                    <p className="font-semibold">Overnight stay in Sigiriya.</p>
                                </div>
                            )}
                        </div>

                        {/* ================= DAY 3 ================= */}
                        <div data-aos="fade-up" data-aos-delay="300" className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay3(!day3)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 3: Sigiriya → Kandy Cultural & Rainforest Adventure</span>
                                <span>{day3 ? "−" : "+"}</span>
                            </button>

                            {day3 && (
                                <div className="space-y-4 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Visit Dambulla Cave Temple en route.</p>
                                    <p>Stop at spice garden experience.</p>
                                    <p>White-water rafting in Kitulgala (adventure activity).</p>
                                    <p>Temple of Tooth Relic & Kandy Lake.</p>
                                    <p className="font-semibold">Overnight stay in Kandy.</p>
                                </div>
                            )}
                        </div>

                        {/* ================= DAY 4 ================= */}
                        <div data-aos="fade-up" className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay4(!day4)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 4: Kandy → Nuwara Eliya (Tea Trails & Waterfalls)</span>
                                <span>{day4 ? "−" : "+"}</span>
                            </button>

                            {day4 && (
                                <div className="space-y-4 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Visit Ramboda Falls.</p>
                                    <p>Tea plantation & factory tour.</p>
                                    <p>Horton Plains optional trek (World’s End).</p>
                                    <p>Explore Nuwara Eliya highlands.</p>
                                    <p className="font-semibold">Overnight stay in Nuwara Eliya.</p>
                                </div>
                            )}
                        </div>

                        {/* ================= DAY 5 ================= */}
                        <div data-aos="fade-up" className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay5(!day5)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 5: Scenic Train → Ella Adventure Hub</span>
                                <span>{day5 ? "−" : "+"}</span>
                            </button>

                            {day5 && (
                                <div className="space-y-4 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Scenic train ride to Ella.</p>
                                    <p>Hike Little Adam’s Peak.</p>
                                    <p>Nine Arches Bridge visit.</p>
                                    <p>Optional zipline adventure in Ella.</p>
                                    <p className="font-semibold">Overnight stay in Ella.</p>
                                </div>
                            )}
                        </div>

                        {/* ================= DAY 6 ================= */}
                        <div data-aos="fade-up" className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay6(!day6)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 6: Ella → Udawalawe Safari Experience</span>
                                <span>{day6 ? "−" : "+"}</span>
                            </button>

                            {day6 && (
                                <div className="space-y-4 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Morning travel via scenic route.</p>
                                    <p>Udawalawe National Park Jeep Safari (wild elephants).</p>
                                    <p>Optional elephant transit home visit.</p>
                                    <p className="font-semibold">Overnight stay near Udawalawe.</p>
                                </div>
                            )}
                        </div>

                        {/* ================= DAY 7 ================= */}
                        <div data-aos="fade-up" className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay7(!day7)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 7: Galle → Mirissa Whale Watching & Bentota Water Sports</span>
                                <span>{day7 ? "−" : "+"}</span>
                            </button>

                            {day7 && (
                                <div className="space-y-4 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Morning whale watching safari in Mirissa.</p>
                                    <p>Visit Galle Fort (UNESCO heritage site).</p>
                                    <p>Beach relaxation & snorkeling.</p>
                                    <p>Bentota water sports (jet ski / banana boat / river safari).</p>
                                    <p className="font-semibold">Overnight stay in Galle / Bentota.</p>
                                </div>
                            )}
                        </div>

                        {/* ================= DAY 8 ================= */}
                        <div data-aos="fade-up" className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay8(!day8)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 8: Departure from Colombo</span>
                                <span>{day8 ? "−" : "+"}</span>
                            </button>

                            {day8 && (
                                <div className="space-y-4 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Transfer to Colombo Airport.</p>
                                    <p>End of adventure tour with unforgettable safari experiences.</p>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            </section>

            {/* ================= ROUTE MAP ================= */}
            <section className="bg-white py-10">
                <div className="mx-auto max-w-7xl px-6">

                    <div
                        className="ch-left mx-auto max-w-5xl"
                        data-aos="fade-right"
                    >
                        <h1
                            data-aos="fade-up"
                            className="mb-6 text-center text-3xl sm:text-4xl md:text-5xl lg:text-4xl font-extrabold leading-tight"
                        >
                            Route
                        </h1>

                        <div className="flex flex-col lg:flex-row gap-6">

                            {/* Map */}
                            <div className="map-container flex-1 overflow-hidden rounded-xl shadow-xl border">
                                <iframe
                                    width="100%"
                                    height="450"
                                    style={{ border: 0 }}
                                    loading="lazy"
                                    allowFullScreen
                                    src="https://www.google.com/maps/embed/v1/directions?key=AIzaSyDZqfXy1xcje1qgbyaF-Kb_qoRtUJc_lik&origin=Bandaranaike+International+Airport+Colombo+Sri+Lanka&destination=Colombo+Sri+Lanka&waypoints=Pinnawala+Elephant+Orphanage+Sri+Lanka|Sigiriya+Sri+Lanka|Minneriya+National+Park+Sri+Lanka|Kandy+Sri+Lanka|Kitulgala+Sri+Lanka|Nuwara+Eliya+Sri+Lanka|Ella+Sri+Lanka|Udawalawe+National+Park+Sri+Lanka|Mirissa+Sri+Lanka|Galle+Fort+Sri+Lanka&avoid=tolls|highways"
                                />
                            </div>

                            {/* Route Info */}
                            <div className="route-info w-full h-[120px] lg:w-[320px] flex flex-col items-start gap-2 rounded-lg bg-gray-100 p-5 text-lg shadow">
                                <p><strong>Distance:</strong> ~850 km</p>
                                <p><strong>Duration:</strong> 7–8 Days Tour Route</p>
                            </div>

                        </div>

                    </div>

                </div>
            </section>

            {/* ================= IMPORTANT INFO + CTA ================= */}
            <section className="bg-white py-10">
                <div className="mx-auto max-w-7xl px-6">

                    {/* Important Points */}
                    <div data-aos="fade-up" className="mx-auto max-w-4xl">
                        <h3 className="mb-6 text-center text-2xl font-bold text-[#0A3A5E]">
                            Important points to note
                        </h3>

                        <ul className="space-y-4 text-gray-700">
                            <li className="flex items-start gap-3">
                                <span className="mt-1 text-[#0A3A5E]">◆</span>
                                <p>
                                    After making the payment, any booking cannot be cancelled.
                                    Hence, once the payment is made it will not be refunded.
                                </p>
                            </li>

                            <li className="flex items-start gap-3">
                                <span className="mt-1 text-[#0A3A5E]">◆</span>
                                <p>
                                    Additional services and excursions that are optional may be provided,
                                    though for an additional charge.
                                </p>
                            </li>

                            <li className="flex items-start gap-3">
                                <span className="mt-1 text-[#0A3A5E]">◆</span>
                                <p>
                                    The official check-in time at all hotels is at 12:00 pm.
                                </p>
                            </li>

                            <li className="flex items-start gap-3">
                                <span className="mt-1 text-[#0A3A5E]">◆</span>
                                <p>
                                    The official check-out time at all hotels is at 11:00 am.
                                </p>
                            </li>

                            <li className="flex items-start gap-3">
                                <span className="mt-1 text-[#0A3A5E]">◆</span>
                                <p>
                                    Visits to wildlife parks will be at one’s own risk. Jeeps and vehicles
                                    available here are without air conditioning and come with basic insurance
                                    covers (not comprehensive as in the case of vehicles used for our tours).
                                </p>
                            </li>
                        </ul>
                    </div>

                    {/* CTA Box */}
                    <div
                        data-aos="zoom-in"
                        className="mt-10 w-full rounded-lg bg-gray-100 px-6 py-10 text-center shadow"
                    >
                        <h2 className="mb-6 text-xl sm:text-2xl font-semibold text-gray-800">
                            Experience your dream holiday in Sri Lanka!
                        </h2>

                        <button
                            onClick={() => navigate(`/book-now`)}
                            className="rounded-full bg-[#00A9C7] px-10 py-3 text-white font-semibold transition hover:bg-[#008eaa]">
                            BEGIN YOUR JOURNEY
                        </button>
                    </div>

                    {/* Related Destinations */}
                    <div data-aos="fade-up" className="mt-10 text-left">
                        <h3 className="mb-6 text-xl font-bold text-gray-700">
                            RELATED DESTINATIONS
                        </h3>

                        <div className="flex flex-wrap justify-start gap-3">
                            {[
                                "Colombo",
                                "Sigiriya",
                                "Kandy",
                                "Nuwara Eliya",
                                "Ella",
                                "Yala",
                                "Minneriya"
                            ].map((place, i) => (
                                <span
                                    key={i}
                                    className="rounded-full bg-gray-200 px-5 py-2 text-sm font-medium text-gray-700 transition hover:bg-[#0A3A5E] hover:text-white cursor-pointer"
                                >
                                    {place}
                                </span>
                            ))}
                        </div>
                    </div>

                </div>
            </section>

            {/* ================= WHATSAPP BUTTON ================= */}
            <a
                href="https://wa.me/94769245905"
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src={require("../../assets/whatsapp.png")}
                    alt="WhatsApp Icon"
                    className="h-12 w-12 rounded-full shadow-lg transition hover:scale-110 sm:h-14 sm:w-14"
                />
            </a>

        </div>
    );
}

export default NatureAndAdventureTour;
